function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M33.87 20.05L32.73 8.98h3.95a2.25 2.25 0 002.24-2.24v-4.5A2.25 2.25 0 0036.68 0H11.23a2.25 2.25 0 00-2.25 2.25v4.49a2.25 2.25 0 002.25 2.24h3.95l-1.15 11.07C9.5 22.15 6 25.95 6 30.69a2.25 2.25 0 002.24 2.25h12.73v9.73c0 .11.03.23.08.33l2.24 4.5a.75.75 0 001.34 0l2.25-4.5a.75.75 0 00.08-.33v-9.73h12.72a2.25 2.25 0 002.25-2.25c0-4.79-3.56-8.55-8.05-10.64z"
})));